import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

/** @deprecated Cleared on load so older installs are not blocked for 7 days */
const LEGACY_STORAGE_KEY = 'welcome-discount-popup-dismissed';

/**
 * Welcome discount popup — opens on each page load; dismiss only lasts until refresh.
 *
 * @extends {DialogComponent}
 */
class WelcomeDiscountPopupComponent extends DialogComponent {
  /** @type {number | undefined} */
  #openTimeoutId;

  /** @type {boolean} */
  #dismissedThisPage = false;

  connectedCallback() {
    super.connectedCallback();

    if (this.dataset.enabled === 'false') return;

    try {
      localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch {
      /* storage unavailable */
    }

    this.addEventListener(DialogCloseEvent.eventName, this.#onDialogClose);

    if (this.#dismissedThisPage) return;

    if (this.dataset.homeOnly === 'true' && this.dataset.template !== 'index') {
      return;
    }

    const delayMs = Math.max(0, Number(this.dataset.delaySeconds || 0)) * 1000;

    if (delayMs === 0) {
      requestAnimationFrame(() => this.#openIfClosed());
      return;
    }

    this.#scheduleOpen(delayMs);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener(DialogCloseEvent.eventName, this.#onDialogClose);
    if (this.#openTimeoutId != null) {
      window.clearTimeout(this.#openTimeoutId);
    }
  }

  #openIfClosed() {
    if (this.#dismissedThisPage) return;

    const { dialog } = this.refs;
    if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;
    this.showDialog();
  }

  /**
   * @param {number} ms
   */
  #scheduleOpen(ms) {
    if (this.#openTimeoutId != null) {
      window.clearTimeout(this.#openTimeoutId);
    }

    this.#openTimeoutId = window.setTimeout(() => this.#openIfClosed(), ms);
  }

  #onDialogClose = () => {
    if (Shopify.designMode) return;
    this.#dismissedThisPage = true;
  };
}

if (!customElements.get('welcome-discount-popup')) {
  customElements.define('welcome-discount-popup', WelcomeDiscountPopupComponent);
}
